<section class="row login-container w-185 custom-login">
        <div [ngSwitch]="viewState" class="w-full">
            <ng-container *ngSwitchCase="loading">
                <gt-app-loader></gt-app-loader>
            </ng-container>   
            <ng-container *ngSwitchCase="loginConstant.REDIRECT">
                <div>
                    <gt-app-loader></gt-app-loader>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="loginConstant.LOGIN">
                <header class="mb-5 text-center">
                <div class="text-12gpx font-bold font-title-poppins-bold opacity-90 text-text-default justify-items-center">Hello there! <span class="font-emoji text-12gpx" [innerHTML]="emoji"></span></div>
                </header>
                <ng-container *ngIf="errorState == 'DEFAULT_LOGIN_FAILURE'">
                    <div class="flex items-center px-5 py-0.3 border border-danger-200 bg-danger-50 rounded-md mb-5">
                       <div class="error-info-icon mr-0.3"></div>
                        <span class="text-sm text-title-default">Invalid User ID or Password. Please try again.</span>
                      </div>
                </ng-container>
                <div class="animate-opacity">
                    <div class="form-container w-full flex flex-col">
                        <form name="form" #login="ngForm" (ngSubmit)="submit()" novalidate>
                            <error-container [errorState]="errorState"></error-container>
                            <div class="form-group">
                              <label for="username" class="mb-1 text-6gpx block text-title-default">Login ID</label>
                              <div class="mb-7 text-6gpx">
                                  <input type="text" 
                                    class="form-control placeholder-gray-300 h-16 w-full text-text-default border border-solid rounded-gt-md-3 focus:outline-none p-3 text-7gpx font-body" 
                                    [placeholder]="userLoginField"
                                    name="username"
                                    id="username"
                                    autocomplete="off"
                                    [ngModel]="loginForm.username"
                                    (ngModelChange)="onUsernameChange($event)"
                                    #username="ngModel"
                                    required
                                    autofocus
                                    [autofocus]="true"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                              <label for="password" class="mb-1 text-6gpx block text-title-default">Password</label>
                              <div class="mb-2 text-6gpx relative">
                                  <input [type]="showPassword ? 'text' : 'password'"
                                    class="form-control placeholder-gray-300 h-16 text-text-default border border-solid w-full rounded-gt-md-3 focus:outline-none text-7gpx p-3 font-body pr-10"
                                    placeholder="Password"
                                    name="password"
                                    id="password"
                                    autocomplete="off"
                                    [ngModel]="loginForm.password"
                                    (ngModelChange)="onPasswordChange($event)"
                                    #password="ngModel"
                                    required
                                    />
                                    <button type="button"
                                        class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                                        (click)="togglePasswordVisibility()">
                                        <div [ngClass]="{
                                            'eye-icon': !showPassword && !loginForm.password,
                                            'show-eye-icon': !showPassword && loginForm.password,
                                            'hide-eye-icon': showPassword
                                        }"></div>
                                    </button>
                                </div>
                            </div>
                            <div class="flex w-full justify-end mb-16 -mt-3 pr-4">
                                <a 
                                    class="text-primary-400 text-7gpx cursor-pointer"
                                    [routerLink]="oAuthPath.FORGET_PASSWORD">
                                    Forgot password?
                                </a>
                            </div>
                            <div class="flex w-full justify-center mb-9">
                                <button
                                [disabled]="isDisableLogin"
                                [ngClass]="{
                                    'bg-secondary-300 cursor-not-allowed': isDisableLogin,
                                    'bg-primary-400 focus:bg-primary-400': !isDisableLogin
                                  }"
                                    class="h-12 items-center justify-center text-white flex w-70x text-7gpx text-body-semibold rounded-gt-md-3"
                                    type="submit">
                                    Login
                                </button>
                            </div>
                        </form>
                        
                        <ng-container *ngIf="!disableOpenIdLogin || !disableSamlLoginBtn">
                            <div class="line-title flex flex-row text-6gpx mb-4 font-body">or join us with</div>
                        </ng-container>
                        <ng-container *ngIf="!disableSamlLoginBtn">
                            <button  class="btn btn-secondary items-center justify-center flex mb-9 h-21 w-full text-7gpx font-body-semibold rounded-gt-md-3 elipsis" type="button" (click)="samlLogin()">
                            {{samlProvider}}
                             </button>
                        </ng-container>
                        <ng-container *ngIf="!disableOpenIdLogin">
                            <div class="flex flex-row justify-center">
                            
                                <div class="w-55 h-30 rounded-gt-md-5 mr-7 overflow-hidden cursor-pointer">
                                    <google-signin [challenge]="challenge"></google-signin>
                                </div>
                                <div class="w-55 h-30 rounded-gt-md-5 mr-7 overflow-hidden cursor-pointer">
                                    <facebook-signin [challenge]="challenge"></facebook-signin>
                                </div>
                                <div class="w-55 h-30 rounded-gt-md-5 mr-5 overflow-hidden cursor-pointer">
                                    <linkedin-signin [challenge]="challenge"></linkedin-signin>
                                </div>     
                            </div>
                            <div class="flex w-full justify-center mt-5">
                                <a
                                    class="text-primary-400 text-7gpx font-semibold font-body-semibold cursor-pointer"
                                    [href]="oAuthPath.NEED_HELP"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    Need help?
                                </a>
                            </div>
                        </ng-container>                     
                    </div>
                </div>
            </ng-container>
        </div>
</section>
